import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEmailValue, setQmateValue, setStopId } from 'redux/counterSlice';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import * as myconst from "../../constants"
import Modal from 'pages/modal';
import {
    copyIcon,
    speakerIcon,
} from 'assets/icons';
import { generateEmail, translateLanguage } from 'services/emailService';
import ActionForEmail from 'components/ActionForEmail';
import { Button } from 'primereact/button';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { FloatLabel } from 'primereact/floatlabel';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { handleActive, handleAgeRange, handleChannel, handleComplexity, handleConstraints, handleDesiredOutcome, handleKeywords, handleLength, handleObjective, handlePlatform, handleProductName, handlePurpose, handleRole, handleStyle, handleTone, handleTopic } from 'redux/persistentSlice';
import { InputTextarea } from 'primereact/inputtextarea';

interface bodyType {
    client_env: string | null,
    generate: boolean | null,
    conversation_id?: string | undefined,
    source_name: string,
    prompt: string,
    settings: {
        role: string,
        tone: string,
        style: string,
        length: string,
        complexity: string,
        keywords: string,
    },
    content?: string,
    title: string,
    subject?: string,
    user_name: string | null,
}

interface translation {
    client_env: string,
    source_name: string,
    language: string,
    content: string,
    conversation_id: string,
    prompt: string,
    settings: object,
    user_name: string,
    subject: string
}
const EmailGeneration = ({ languageTranslated, setLanguageTranslated, getConversations, component, p_id, source_name, setCurrent, isDeleteClicked, setIsDeleteClicked, handleDelete, deleteConfirmation, userQuery, setUserQuery, setAnswer, answer, notify, emailData, setEmailData, handleCoversationByVersion }: any) => {
    const dispatch = useDispatch();
    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const TextspeechFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.textSpeech]
    const copyFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.copy]
    const elementRef: any = useRef(null);
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname.split('/').filter(entry => entry.trim() !== '');
    const emailValue = useSelector((state: any) => state.counter.emailValue);
    const stopId = useSelector((state: any) => state.counter.stopId);
    const [isEmailClicked, setIsEmailClicked] = useState([]);
    const [isLanguageTranslateClicked, setIsLanguageTranslateClicked] = useState(false);
    const [inputDescription, setInputDescription] = useState("");
    const roleDropdown = useSelector((state: any) => state.persistent.roleDropdown);
    const toneDropdown = useSelector((state: any) => state.persistent.toneDropdown);
    const styleDropdown = useSelector((state: any) => state.persistent.styleDropdown);
    const lengthDropdown = useSelector((state: any) => state.persistent.lengthDropdown);
    const complexityDropdown = useSelector((state: any) => state.persistent.complexityDropdown);
    const ageRangeDropdown = useSelector((state: any) => state.persistent.ageRangeDropdown);
    const objectiveDropdown = useSelector((state: any) => state.persistent.objectiveDropdown);
    const platformDropdown = useSelector((state: any) => state.persistent.platformDropdown);
    const channelDropdown = useSelector((state: any) => state.persistent.channelDropdown);
    const desiredOutcomeDropDown = useSelector((state: any) => state.persistent.desiredOutcomeDropDown);
    const keywords = useSelector((state: any) => state.persistent.keywords);
    const constraints = useSelector((state: any) => state.persistent.constraintsDropdown);
    const key_features = useSelector((state: any) => state.persistent.key_features);
    const product_name = useSelector((state: any) => state.persistent.product_name);
    const purpose = useSelector((state: any) => state.persistent.purpose);
    const topic = useSelector((state: any) => state.persistent.topic);
    const currentActive = useSelector((state: any) => state.persistent.currentActive);
    const constraintsDropdown = useSelector((state: any) => state.persistent.constraintsDropdown);

    const connectorsListRole = [
        { name: "Sales Executive" },
        { name: "Software Engineer" },
        { name: "Product Manager" },
        { name: "Customer Support Specialist" },
        { name: "Marketing Manager" },
        { name: "Human Resources Manager" },
        { name: "Finance Analyst" },
        { name: "Operations Manager" },
        { name: "Data Scientist" },
        { name: "Graphic Designer" },
        { name: "Other" },
    ]
    const connectorsListTone = [
        { name: "Casual" },
        { name: "Friendly" },
        { name: "Formal" },
        { name: "Professional" },
    ]
    const connectorsListStyle = [
        { name: "Concise" },
        { name: "Neutral" },
        { name: "Polite" },
        { name: "Persuasive" },
    ]
    const connectorsListLength = [
        { name: "Short" },
        { name: "Medium" },
        { name: "Long" }
    ]
    const connectorsListComplexity = [
        { name: "Simple" },
        { name: "Moderate" },
        { name: "Detailed" }
    ]
    const connectorsListAgeRange = [
        { name: "15-20" },
        { name: "20-25" },
        { name: "25-30" },
    ]
    const connectorsListObjective = [
        { name: "Marketing" },
        { name: "Campaign" },
        { name: "Product Innovation" },
        { name: "Content Creation" },
        { name: "Problem Solving" },
    ]
    const connectorsListPlatform = [
        { name: "Twitter" },
        { name: "Instagram" },
        { name: "Facebook" },
        { name: "Linkedin" },
    ]
    const connectorsListChannel = [
        { name: "Online store" },
        { name: "E-commerce website" },
        { name: "Retail store" },
    ]
    const connectorsListDesiredOutcome = [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
    ]
    const connectorsListConstraints = [
        { name: "Budget" },
        { name: "Compatibility" },
        { name: "User Privacy" },
        { name: "Technology" },
    ]

    const userName = localStorage.getItem("username")
    const promptText = "This chat will be deleted, along with all related activity, including prompt and responses from your RysunAI activity."
    const firstLetter = userName?.charAt(0).toUpperCase();
    const confirm1 = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Text Copied',
        });
    };
    const handleSpeak = (screenText: any, id: any) => {
        const clearedText = screenText.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
        if ('speechSynthesis' in window) {
            const synth = window.speechSynthesis;
            if (synth.speaking) {
                synth.cancel();
                dispatch(setStopId(''));
            }
            if (stopId != id) {
                const utterance = new SpeechSynthesisUtterance(clearedText);

                // Optional settings for the speech
                utterance.lang = 'en-US'; // Language (e.g., US English)
                utterance.volume = 1; // Volume (0 to 1)
                utterance.rate = 1; // Rate of speech (0.1 to 10)
                utterance.pitch = 1; // Pitch (0 to 2)

                // Speak the text
                synth.speak(utterance);
                dispatch(setStopId(id));

                utterance.onend = () => {
                    dispatch(setStopId(null));
                };
            }
        }

    };
    //Handle copy button
    const handleCopy = (text: string) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            // setCopySuccess('Text copied to clipboard using fallback method');
            console.log('Text copied to clipboard using fallback method');
        } catch (error) {
            console.error('Error copying text with fallback method:', error);
            // setCopySuccess('Failed to copy text');
        }
        document.body.removeChild(textArea);
    };
    //Handle user userQuery of chat conversation
    useEffect(() => {
        setCurrent(params.id);
    })
    //Handle download button
    const handleDownload = (ques: any, ans: any) => {
        const user = 'H';
        const timestamp = new Date();
        const formattedDate = timestamp.toLocaleDateString('en-US', {});
        const formattedTime = timestamp.toLocaleTimeString('en-US', {});

        const content = source_name === "email_generation" ? `Query: ${ques}\n\nSubject: ${ans.subject}\n\nAnswer: ${ans.response.output_text}` : `Query: ${ques}\n\nAnswer: ${ans.response.output_text}`;
        const blob = new Blob([content], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `${user} ${formattedDate} ${formattedTime}`;
        document.body.appendChild(a);

        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };


    const handleSendQueryButton = async () => {
        setAnswer([]);
        setInputDescription("")
        if (elementRef.current) {
            elementRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        const startTime = performance.now(); // Start the timer
        try {
            if (params.id === p_id) {
                const newQuery = {
                    que: emailValue,
                    isUser: true,
                };
                setUserQuery([newQuery]);
                // dispatch(setQmateValue(""));
            } else {
                const newQuery = {
                    que: emailData.prompt,
                    isUser: true,
                };

                setUserQuery([newQuery]);
            }
            let settingsGen: any = {}
            if (source_name === "email_generation") {
                settingsGen.role = roleDropdown.name;
                settingsGen.tone = toneDropdown.name;
                settingsGen.style = styleDropdown.name;
                settingsGen.length = lengthDropdown.name;
                settingsGen.complexity = complexityDropdown.name;
                settingsGen.keywords = keywords.split(",")
            } else if (source_name === "post_generation") {
                settingsGen.age_range = ageRangeDropdown.name;
                settingsGen.objective = objectiveDropdown.name;
                settingsGen.tone = toneDropdown.name;
                settingsGen.style = styleDropdown.name;
                settingsGen.platform = platformDropdown.name;
                settingsGen.keywords = keywords.split(",")
            } else if (source_name === "product_generation") {
                settingsGen.demography = ageRangeDropdown.name;
                // settingsGen.age_range = ageRangeDropdown.name;
                settingsGen.channel = channelDropdown.name;
                settingsGen.tone = toneDropdown.name;
                settingsGen.style = styleDropdown.name;
                settingsGen.keywords = keywords.split(",")
                settingsGen.key_features = key_features.split(",");
                settingsGen.product_name = product_name;
            } else if (source_name === "article_generation") {
                settingsGen.role = roleDropdown.name;
                settingsGen.style = styleDropdown.name;
                settingsGen.length = lengthDropdown.name;
                settingsGen.topic = topic;
                settingsGen.purpose = purpose;
            } else if (source_name === "idea_generation") {
                settingsGen.objective = objectiveDropdown.name;
                settingsGen.desired_outcome = desiredOutcomeDropDown.name;
                settingsGen.constraints = [constraints.name];
            }
            const body: bodyType = {
                client_env: localStorage.getItem('clientName'),
                generate: true,
                source_name,
                prompt: params.id === p_id ? emailValue : emailData.prompt,
                title: params.id === p_id ? emailValue : emailData.prompt,
                settings: settingsGen,
                user_name: localStorage.getItem('username')
            };
            if (params.id !== p_id) {
                body.conversation_id = params.id
            }
            const { result, error } = await generateEmail(body);

            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // setEmailData(result);
            // const endTime = performance.now(); // End the timer
            // const elapsedTime = endTime - startTime; // Calculate elapsed time
            // await handleCreateCon(result, elapsedTime);
            await handleLanguageTranslate(result);
            if (params.id === p_id) {
                navigate(`/${component}/${result.conversation_id}`, { replace: true });
                getConversations();
            }
            dispatch(setEmailValue(""));
            if (elementRef.current) {
                elementRef.current.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleLanguageTranslate = async (lan: any) => {
        const body: any = {
            client_env: localStorage.getItem('clientName'),
            source_name,
            language: emailData.language !== undefined ? emailData.language : "english",
            content: lan.content,
            conversation_id: lan.conversation_id,
            message_id: lan.message_id,
            prompt: lan.prompt,
            title: lan.title,
            settings: lan.settings,
            user_name: lan.user_name,
        }
        if (source_name === "email_generation") {
            body.subject = lan.subject
        }
        const startTime = performance.now();
        try {
            const { result, error } = await translateLanguage(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setEmailData(result);
            const endTime = performance.now(); // End the timer
            const elapsedTime = endTime - startTime; // Calculate elapsed time
            await handleCreateCon(result, elapsedTime);
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleRegenerate = async () => {
        const startTime = performance.now();
        setAnswer([]);
        try {
            const body: bodyType = {
                client_env: localStorage.getItem('clientName'),
                generate: false,
                conversation_id: params.id,
                source_name,
                prompt: emailData.prompt,
                title: emailData.title,
                settings: emailData.settings,
                subject: emailData.subject,
                user_name: emailData.user_name
            }
            const { result, error } = await generateEmail(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            await handleLanguageTranslate(result);
            // setEmailData(result);
            // const endTime = performance.now(); // End the timer
            // const elapsedTime = endTime - startTime; // Calculate elapsed time
            // await handleCreateCon(result, elapsedTime);

        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleSubjectRegenerate = async () => {
        const startTime = performance.now();
        setAnswer([]);
        try {
            const body: bodyType = {
                client_env: localStorage.getItem('clientName'),
                generate: null,
                conversation_id: params.id,
                source_name,
                title: emailData.title,
                prompt: emailData.prompt,
                settings: emailData.settings,
                content: emailData.content,
                subject: emailData.subject,
                user_name: emailData.user_name
            }
            const { result, error } = await generateEmail(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            await handleLanguageTranslate(result);
            // setEmailData(result);
            // const endTime = performance.now(); // End the timer
            // const elapsedTime = endTime - startTime; // Calculate elapsed time
            // await handleCreateCon(result, elapsedTime);

        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleCreateCon = async (result: any, elapsedTime: number) => {
        let newQuery = {
            que: result?.prompt,
            isUser: true,
        };
        setUserQuery([newQuery]);
        // setUserQuery([...userQuery, newQuery]);
        let obj: any = {
            ans: {
                response: {
                    output_text:
                        result?.content?.replace(/`/g, "\n\n"),
                },
                subject: result?.subject,
                id: result?.message_id,
                created_time: result?.created_at,
                version: result?.version,
                total_versions: result?.total_versions
            },
        };
        if (result?.language !== undefined) {
            setLanguageTranslated({ name: myconst.capitalizeFirstLetter(result?.language) })
        } else {
            setLanguageTranslated({ name: "English" })
        }
        setAnswer([obj]);

        if (params.id == p_id) {
            setCurrent(0);
        }
        setTimeout(() => {
            const conversationContainer: any = document.querySelector(
                '.chats-conversation-container'
            );
            conversationContainer!.scrollBottom =
                conversationContainer.scrollHeight;
        }, 10);
    };
    useEffect(() => {
        if (emailValue !== "") {
            handleSendQueryButton();
        }
    }, [emailValue]);

    const MarkdownRenderer = ({ content }: any) => {
        return (
            <ReactMarkdown
                components={{
                    // Paragraphs
                    p: ({ node, ...props }) => <p  {...props} />,

                    // Headings
                    h1: ({ node, ...props }) => (
                        <h1
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2

                            {...props}
                        />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3

                            {...props}
                        />
                    ),
                    h4: ({ node, ...props }) => (
                        <h4

                            {...props}
                        />
                    ),
                    h5: ({ node, ...props }) => (
                        <h5

                            {...props}
                        />
                    ),
                    h6: ({ node, ...props }) => (
                        <h6

                            {...props}
                        />
                    ),

                    // Lists
                    ul: ({ node, ...props }) => (
                        <ul

                            {...props}
                        />
                    ),
                    ol: ({ node, ordered, ...props }) => (
                        <ol

                            {...props}
                        />
                    ),

                    // List Items
                    li: ({ node, ordered, ...props }) => (
                        <li

                            {...props}
                        />
                    ),

                    // Links
                    a: ({ node, ...props }: any) => (
                        <a

                            href={node.href}
                            {...props}
                        >
                            {props.children}
                        </a>
                    ),

                    // Code Blocks styling or auto formatting API response...
                    pre: ({ node, ...props }) => (
                        <pre

                            {...props}
                        />
                    ),
                    code: ({ inline, node, ...props }) => {
                        if (inline) {
                            return (
                                <code

                                    {...props}
                                />
                            );
                        }
                        return (
                            //     <SyntaxHighlighter language="javascript" >
                            //     {props.children}
                            // </SyntaxHighlighter>

                            <p>{props.children}</p>
                        );
                    },

                    // Blockquotes
                    blockquote: ({ node, ...props }) => (
                        <blockquote

                            {...props}
                        />
                    ),

                    // Images
                    img: ({ node, ...props }: any) => (
                        <img

                            src={node.src}
                            alt={node.alt}
                            {...props}
                        />
                    ),

                    // Table Headers
                    th: ({ node, ...props }) => (
                        <th

                            {...props}
                        />
                    ),

                    // Table Cells
                    td: ({ node, ...props }) => (
                        <td

                            {...props}
                        />
                    ),

                    // Add other components and styles as needed
                }}
                remarkPlugins={[remarkBreaks]}
            >
                {content}
            </ReactMarkdown>
        );
    };
    const handleEmailClick = (index: any) => {
        const updatedEmailClick: any = [...isEmailClicked];
        updatedEmailClick[index] = !updatedEmailClick[index];
        setIsEmailClicked(updatedEmailClick);
    };

    const handleCurrent = () => {

        switch (currentPath[0]) {
            case "generate-email":
                dispatch(handleActive("generateEmail"));
                break;
            case "generate-post":
                dispatch(handleActive("generatePost"));
                break;
            case "generate-article":
                dispatch(handleActive("generateArticle"));
                break;
            case "generate-idea":
                dispatch(handleActive("generateIdea"));
                break;
            case "generate-product":
                dispatch(handleActive("generateProduct"));
                break;
        }
    }
    useEffect(() => {
        handleCurrent();
    }, [])

    return (
        <div className='generation-section'>
            <div className={`${userQuery?.length > 0 && `generation-filter-section ${currentPath[1] !== p_id && 'generation-filter-section-background'}`}`}>
                {(currentPath[1] !== p_id && userQuery?.length > 0) && <>
                    <p className='filter-heading'>Filters</p>
                    <div className='chat-history-data-section'>
                        <div className='mb-4 mt-4'>
                            {(currentActive === 'generateEmail' || currentActive === 'generateArticle') &&
                                <div className='voice-filter-col generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId="dd-role" value={roleDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleRole(e.value))} options={connectorsListRole} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label className="w-full text-sm" htmlFor="dd-role">Select Role</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                                <div className='voice-filter-col  generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId="dd-tone" value={toneDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleTone(e.value))} options={connectorsListTone} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label className="text-sm" htmlFor="dd-tone">Select Tone</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct' || currentActive === 'generateArticle') &&
                                <div className='voice-filter-col generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId="dd-style" value={styleDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleStyle(e.value))} options={connectorsListStyle} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label className='text-sm' htmlFor="dd-style">Select Style</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generateEmail' || currentActive === 'generateArticle') &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-length' value={lengthDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleLength(e.value))} options={connectorsListLength} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label className='text-sm' htmlFor='dd-length' >Select Length</label>
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateEmail' &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-complexity' value={complexityDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleComplexity(e.value))} options={connectorsListComplexity} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-complexity' className='text-sm' >Select Complexity</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-age' value={ageRangeDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleAgeRange(e.value))} options={connectorsListAgeRange} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-age' className='text-sm' >Select Age Range</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generatePost' || currentActive === 'generateIdea') &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-objective' value={objectiveDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleObjective(e.value))} options={connectorsListObjective} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-objective' className='text-sm' >Select Objective</label>
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generatePost' &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-platform' value={platformDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handlePlatform(e.value))} options={connectorsListPlatform} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-platform' className='text-sm' >Select Platform</label>
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateProduct' &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-channel' value={channelDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleChannel(e.value))} options={connectorsListChannel} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-channel' className='text-sm' >Select Channel</label>
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateIdea' &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-desired' value={desiredOutcomeDropDown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleDesiredOutcome(e.value))} options={connectorsListDesiredOutcome} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-desired' className='text-sm' >Select Desired Outcome</label>
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateIdea' &&
                                <div className='voice-filter-col   generation-filter-dropdown'>
                                    <FloatLabel>
                                        <Dropdown inputId='dd-constraint' value={constraintsDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleConstraints(e.value))} options={connectorsListConstraints} optionLabel="name"
                                            className="outline-select w-full" />
                                        <label htmlFor='dd-constraint' className='text-sm' >Select Constraint</label>
                                    </FloatLabel>
                                </div>
                            }
                            {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                                <div className='mt-1 mb-4 voice-filter-col   generation-filter-dropdown  text-sm'>
                                    <FloatLabel>
                                        <label className='text-sm' htmlFor="key">Keywords</label>
                                        <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: "284px" }} className='radius-input ms-2' placeholder='Enter Keyword' value={keywords} onChange={(e) => dispatch(handleKeywords(e.target.value))} />
                                    </FloatLabel>
                                </div>
                            }
                            {/* {currentActive === 'generateProduct' &&
                        <div className='mt-1 mb-4 voice-filter-col  generation-filter-dropdown  text-sm'>
                            <FloatLabel>
                            <label className='text-sm' htmlFor="key">Key Feature</label>
                            <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none" }} className='radius-input ms-2' placeholder='Enter Key Feature' value={key_features} onChange={(e) => dispatch(handleKeyFeatures(e.target.value))} />
                            </FloatLabel>
                        </div>
                        } */}
                            {currentActive === 'generateProduct' &&
                                <div className='mb-4 voice-filter-col  generation-filter-dropdown label-filter-col text-sm'>
                                    <FloatLabel>
                                        <label className='text-sm' htmlFor="key">Product Name</label>
                                        <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: "284px" }} className='radius-input ms-2' placeholder='Enter Product Name' value={product_name} onChange={(e) => dispatch(handleProductName(e.target.value))} />
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateArticle' &&
                                <div className='mt-1 mb-4  voice-filter-col  generation-filter-dropdown  text-sm'>
                                    <FloatLabel>
                                        <label className='text-sm' htmlFor="key">Purpose:</label>
                                        <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: "284px" }} className='radius-input ms-2' placeholder='Enter Purpose' value={purpose} onChange={(e) => dispatch(handlePurpose(e.target.value))} />
                                    </FloatLabel>
                                </div>
                            }
                            {currentActive === 'generateArticle' &&
                                <div className='mb-4 voice-filter-col  generation-filter-dropdown label-filter-col text-sm'>
                                    <FloatLabel>
                                        <label className='text-sm' htmlFor="key">Topic:</label>
                                        <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: "284px" }} className='radius-input ms-2' placeholder='Enter Topic' value={topic} onChange={(e) => dispatch(handleTopic(e.target.value))} />
                                    </FloatLabel>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='describe-section'>
                        {/* <div className='mt-1 mb-2 generation-filter-dropdown text-sm'>
                        <FloatLabel>
                        <label className='text-sm mb-2 mt-4' htmlFor="key">Describe what you want to see</label>
                        <InputTextarea rows={3} className="textarea-describe w-full" placeholder='Enter Keyword' value={inputDescription} onChange={(e) => setInputDescription(e.target.value)} />
                        </FloatLabel>
                    </div> */}
                        <Button className="btn-voice-list outline-icon-btn" onClick={() => handleSendQueryButton()}>Generate</Button>
                    </div>
                </>}
            </div>
            <section
                className={`chat-component-main-section`}
            >
                <div className='chat-component-main-container'>
                    <div className='chats-conversation-container' ref={elementRef}>
                        {userQuery?.map((userMessage: any, index: any) => {
                            if (
                                answer?.length > 1 &&
                                index == 0 &&
                                answer[0]?.ans.isFirst
                            )
                                return;
                            else
                                return (
                                    <div
                                        className={'chats-conversation'}
                                        // className={currentPath[1] !== "new-chat" ? 'chats-conversation' : ""}
                                        key={index}
                                        style={{ position: 'relative', borderBottom: currentPath[1] === p_id ? 'none' : "" }}
                                    >
                                        <div className='user chat-user-head'>
                                            <div className='chat-user-left'>
                                                {answer[index]?.ans.isFirst ? (
                                                    <i style={{ width: '34px', height: '34px', marginRight: '15px' }}>
                                                        {/* <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M22.1735 8.62979C24.7787 8.63286 27.2763 9.66914 29.1185 11.5113C30.9606 13.3534 31.9969 15.851 31.9999 18.4562C32.0091 21.0175 31.0057 23.4787 29.2083 25.3035L31.4238 27.5189C31.4856 27.5818 31.5275 27.6616 31.5442 27.7482C31.5609 27.8348 31.5516 27.9244 31.5176 28.0058C31.4847 28.0878 31.4279 28.158 31.3547 28.2074C31.2814 28.2568 31.195 28.283 31.1066 28.2827H22.1735C19.5674 28.2827 17.068 27.2474 15.2252 25.4046C13.3824 23.5618 12.3471 21.0624 12.3471 18.4562C12.3471 15.8501 13.3824 13.3507 15.2252 11.5079C17.068 9.66508 19.5674 8.62979 22.1735 8.62979Z" fill="#6FBE46" />
                                                                <path opacity="0.7" d="M9.82648 0C7.2213 0.00307342 4.72369 1.03934 2.88155 2.8815C1.0394 4.72365 0.00313536 7.22126 6.19537e-05 9.82645C-0.0090821 12.3878 0.994316 14.8489 2.79166 16.6737L0.576248 18.8891C0.51439 18.952 0.472488 19.0318 0.4558 19.1184C0.439113 19.205 0.448384 19.2946 0.48245 19.376C0.515313 19.458 0.57206 19.5282 0.64533 19.5776C0.718601 19.627 0.805017 19.6532 0.893373 19.6529H9.82648C12.4326 19.6529 14.932 18.6176 16.7748 16.7748C18.6176 14.932 19.6529 12.4326 19.6529 9.82645C19.6529 7.22032 18.6176 4.72092 16.7748 2.8781C14.932 1.03528 12.4326 0 9.82648 0Z" fill="#0512C4" />
                                                                <path d="M8.64249 11.3107V11.1493C8.64558 10.5952 8.69344 10.1536 8.78608 9.82433C8.8818 9.49507 9.02075 9.22914 9.20292 9.02652C9.3851 8.8239 9.60433 8.64028 9.86062 8.47565C10.0521 8.34901 10.2234 8.21763 10.3747 8.08149C10.526 7.94536 10.6465 7.79498 10.736 7.63035C10.8255 7.46256 10.8703 7.27577 10.8703 7.06998C10.8703 6.85153 10.8194 6.66 10.7175 6.49537C10.6156 6.33074 10.4782 6.2041 10.3053 6.11546C10.1354 6.02681 9.94708 5.98249 9.7402 5.98249C9.53949 5.98249 9.34959 6.0284 9.1705 6.12021C8.99141 6.20885 8.84474 6.34182 8.7305 6.51911C8.61625 6.69324 8.55449 6.9101 8.54523 7.16971H6.65552C6.67096 6.53653 6.81917 6.01415 7.10016 5.60258C7.38114 5.18785 7.75322 4.87917 8.21638 4.67655C8.67955 4.47077 9.19057 4.36787 9.74946 4.36787C10.3639 4.36787 10.9074 4.47235 11.3798 4.6813C11.8522 4.88708 12.2228 5.18626 12.4914 5.57884C12.76 5.97141 12.8943 6.44471 12.8943 6.99875C12.8943 7.36916 12.8341 7.69842 12.7137 7.98651C12.5964 8.27145 12.4312 8.52472 12.2181 8.74633C12.0051 8.96478 11.7534 9.16265 11.4632 9.33994C11.2192 9.48874 11.0185 9.64387 10.8611 9.80533C10.7067 9.96679 10.5909 10.1536 10.5137 10.3657C10.4396 10.5778 10.401 10.839 10.3979 11.1493V11.3107H8.64249ZM9.55956 14.35C9.25078 14.35 8.98678 14.2392 8.76755 14.0176C8.55141 13.7928 8.44488 13.5237 8.44797 13.2103C8.44488 12.9 8.55141 12.6341 8.76755 12.4125C8.98678 12.1908 9.25078 12.08 9.55956 12.08C9.8529 12.08 10.1107 12.1908 10.333 12.4125C10.5554 12.6341 10.6681 12.9 10.6712 13.2103C10.6681 13.4192 10.614 13.6108 10.509 13.7849C10.4072 13.9558 10.2728 14.0936 10.1061 14.198C9.93936 14.2993 9.75718 14.35 9.55956 14.35Z" fill="#F5F5F5" />
                                                                <path d="M20.7172 21.9114H19.2623L21.9113 14.3871H23.5939L26.2465 21.9114H24.7917L22.782 15.9302H22.7232L20.7172 21.9114ZM20.765 18.9612H24.7329V20.0561H20.765V18.9612Z" fill="white" />
                                                            </svg> */}
                                                    </i>
                                                ) : (
                                                    <div className="user-icon" > {firstLetter} </div>
                                                )}
                                                <p className='query'>
                                                    {userMessage?.que}
                                                </p>
                                            </div>
                                            <div className='chat-user-right'>
                                                {(!answer[index]?.ans.isFirst && (TextspeechFlag === true || TextspeechFlag === undefined)) && (
                                                    <span className='conversation-section-icon-top'
                                                        onClick={() =>
                                                            handleSpeak(
                                                                userMessage.que,
                                                                answer[index]?.ans
                                                                    .id
                                                            )
                                                        }
                                                        style={
                                                            stopId ==
                                                                answer[index]?.ans.id
                                                                ? {
                                                                    backgroundColor:
                                                                        '#F1F1F1',
                                                                    border: '1px solid #404040',
                                                                    borderRadius:
                                                                        '50%',
                                                                }
                                                                : {}
                                                        }>
                                                        <img
                                                            data-tooltip-id='my-tooltip'
                                                            data-tooltip-content='Text-to-Speech'
                                                            title='Text to Speech'
                                                            className='speaker-button'
                                                            src={speakerIcon}
                                                            alt='copy-button'

                                                        />
                                                    </span>
                                                )}
                                                {(!answer[index]?.ans.isFirst && (copyFlag === true || copyFlag === undefined)) && (
                                                    <span className='conversation-section-icon-top'
                                                        onClick={(e) => {
                                                            handleCopy(
                                                                userMessage.que
                                                            )
                                                            confirm1(e)
                                                        }
                                                        }
                                                    >
                                                        <img
                                                            data-tooltip-id='my-tooltip'
                                                            data-tooltip-content='Copy'
                                                            title='Copy'
                                                            className='copy-button'
                                                            src={copyIcon}
                                                            alt='copy-button'

                                                        />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='chat-user-body'>
                                            <div className='bot'>
                                                {!answer[index]?.ans
                                                    .isFirst && (
                                                        // <img
                                                        //     src={brandLogo}
                                                        //     alt='bot-icon'
                                                        // />
                                                        <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21 2.25H6C3.92893 2.25 2.25 3.92893 2.25 6V19.625C2.25 21.6961 3.92893 23.375 6 23.375H6.70062C8.21893 23.375 9.51331 24.4654 9.77736 25.9528L12.6785 23.9347C13.2022 23.5703 13.825 23.375 14.463 23.375H21C23.0711 23.375 24.75 21.6961 24.75 19.625V6C24.75 3.92893 23.0711 2.25 21 2.25ZM13.3923 24.9608C13.7065 24.7422 14.0802 24.625 14.463 24.625H21C23.7614 24.625 26 22.3864 26 19.625V6C26 3.23858 23.7614 1 21 1H6C3.23858 1 1 3.23858 1 6V19.625C1 22.3864 3.23858 24.625 6 24.625H6.70062C7.6275 24.625 8.4153 25.3022 8.55439 26.2186L8.84375 29L13.3923 24.9608Z" fill="#5627D9" stroke="#5627D9" stroke-width="0.7" />
                                                            <path d="M9.3125 17.7059H18.0625V19.375H9.3125V17.7059Z" fill="#5627D9" />
                                                            <path d="M12.5334 16.0368V15.955C12.5425 15.0871 12.6332 14.3964 12.8056 13.8829C12.9781 13.3694 13.2231 12.9536 13.5407 12.6355C13.8583 12.3174 14.2395 12.0243 14.6842 11.7562C14.9519 11.5926 15.1924 11.3995 15.4057 11.1769C15.6189 10.9496 15.7868 10.6884 15.9093 10.393C16.0364 10.0976 16.0999 9.77044 16.0999 9.41145C16.0999 8.96613 15.9955 8.57988 15.7868 8.2527C15.5781 7.92552 15.299 7.67332 14.9496 7.4961C14.6002 7.31888 14.2123 7.23027 13.7857 7.23027C13.4137 7.23027 13.0552 7.30752 12.7103 7.46202C12.3655 7.61652 12.0774 7.85963 11.8459 8.19135C11.6145 8.52308 11.4807 8.95704 11.4444 9.49325H9.72917C9.76547 8.72075 9.96512 8.05957 10.3281 7.50973C10.6957 6.95989 11.1789 6.53956 11.7779 6.24874C12.3814 5.95791 13.0507 5.8125 13.7857 5.8125C14.5844 5.8125 15.2786 5.97154 15.8685 6.28963C16.4629 6.60772 16.9212 7.04396 17.2434 7.59834C17.5701 8.15273 17.7334 8.78436 17.7334 9.49325C17.7334 9.9931 17.6563 10.4452 17.502 10.8497C17.3523 11.2541 17.1345 11.6154 16.8486 11.9334C16.5673 12.2515 16.227 12.5333 15.8277 12.7787C15.4283 13.0286 15.1084 13.2921 14.868 13.5693C14.6275 13.842 14.4528 14.1669 14.3439 14.5441C14.235 14.9212 14.176 15.3915 14.1669 15.955V16.0368H12.5334Z" fill="#5627D9" />
                                                            <path d="M9.3125 17.7059H18.0625V19.375H9.3125V17.7059Z" stroke="#5627D9" stroke-width="0.5" />
                                                            <path d="M12.5334 16.0368V15.955C12.5425 15.0871 12.6332 14.3964 12.8056 13.8829C12.9781 13.3694 13.2231 12.9536 13.5407 12.6355C13.8583 12.3174 14.2395 12.0243 14.6842 11.7562C14.9519 11.5926 15.1924 11.3995 15.4057 11.1769C15.6189 10.9496 15.7868 10.6884 15.9093 10.393C16.0364 10.0976 16.0999 9.77044 16.0999 9.41145C16.0999 8.96613 15.9955 8.57988 15.7868 8.2527C15.5781 7.92552 15.299 7.67332 14.9496 7.4961C14.6002 7.31888 14.2123 7.23027 13.7857 7.23027C13.4137 7.23027 13.0552 7.30752 12.7103 7.46202C12.3655 7.61652 12.0774 7.85963 11.8459 8.19135C11.6145 8.52308 11.4807 8.95704 11.4444 9.49325H9.72917C9.76547 8.72075 9.96512 8.05957 10.3281 7.50973C10.6957 6.95989 11.1789 6.53956 11.7779 6.24874C12.3814 5.95791 13.0507 5.8125 13.7857 5.8125C14.5844 5.8125 15.2786 5.97154 15.8685 6.28963C16.4629 6.60772 16.9212 7.04396 17.2434 7.59834C17.5701 8.15273 17.7334 8.78436 17.7334 9.49325C17.7334 9.9931 17.6563 10.4452 17.502 10.8497C17.3523 11.2541 17.1345 11.6154 16.8486 11.9334C16.5673 12.2515 16.227 12.5333 15.8277 12.7787C15.4283 13.0286 15.1084 13.2921 14.868 13.5693C14.6275 13.842 14.4528 14.1669 14.3439 14.5441C14.235 14.9212 14.176 15.3915 14.1669 15.955V16.0368H12.5334Z" stroke="#5627D9" stroke-width="0.5" />
                                                        </svg>
                                                    )}
                                                {/* <div style={{fontSize: "14px"}}>
                                                    Subject: {answer[index]?.ans?.subject}
                                                </div> */}
                                                {answer?.length == 1 &&
                                                    index == 0 &&
                                                    answer[0]?.ans.isFirst ? (
                                                    <div
                                                        className='answer'
                                                    >

                                                    </div>
                                                ) : (
                                                    <div className='answer'>
                                                        {answer[index]?.ans?.subject && (
                                                            <div style={{ fontSize: "14px" }}>
                                                                <b>Subject</b>: {answer[index]?.ans?.subject}
                                                            </div>
                                                        )}
                                                        {answer[index]?.ans
                                                            .response
                                                            .output_text !==
                                                            undefined ? (
                                                            // ? answer[index]?.ans.response.output_text
                                                            <MarkdownRenderer
                                                                content={
                                                                    answer[
                                                                        index
                                                                    ]?.ans
                                                                        .response
                                                                        .output_text
                                                                }
                                                            />
                                                        ) : (
                                                            // : <LoadingAnimationSVG /> : <p>something went wrong</p>
                                                            <div className='loading-animation'>
                                                                <div className='line line1'></div>
                                                                <div className='line line2'></div>
                                                                <div className='line line3'></div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            {(
                                                !answer[index]?.ans?.isFirst && answer[index]?.ans?.response !== undefined
                                            ) && (
                                                    <ActionForEmail
                                                        source_name={source_name}
                                                        isLanguageTranslateClicked={isLanguageTranslateClicked}
                                                        setIsLanguageTranslateClicked={setIsLanguageTranslateClicked}
                                                        handleCoversationByVersion={handleCoversationByVersion}
                                                        stopId={stopId}
                                                        notify={notify}
                                                        answer={answer}
                                                        handleCreateCon={handleCreateCon}
                                                        setAnswer={setAnswer}
                                                        emailData={emailData}
                                                        setEmailData={setEmailData}
                                                        index={index}
                                                        userMessage={userMessage}
                                                        handleCopy={handleCopy}
                                                        handleSpeak={handleSpeak}
                                                        handleEmailClick={
                                                            handleEmailClick
                                                        }
                                                        isEmailClicked={
                                                            isEmailClicked
                                                        }
                                                        handleDownload={
                                                            handleDownload
                                                        }
                                                        confirm1={confirm1}
                                                        setLanguageTranslated={setLanguageTranslated}
                                                        languageTranslated={languageTranslated}
                                                    />
                                                )}
                                            {(
                                                !answer[index]?.ans?.isFirst && answer[index]?.ans?.response !== undefined
                                            ) && (<div className='d-flex flex-wrap flex-row-reverse w-100 mt-4'>
                                                {source_name === "email_generation" &&
                                                    <Button className='outline-active-btn btn-lg' onClick={handleSubjectRegenerate} label='Subject Regenerate'></Button>
                                                }
                                                <Button className={`outline-active-btn btn-lg ${source_name === "email_generation" ? "me-2" : ""}`} onClick={handleRegenerate} label='Regenerate'></Button>
                                            </div>)}
                                        </div>
                                    </div>
                                )
                        })}
                    </div>
                    <Modal
                        date={deleteConfirmation?.date}
                        index={deleteConfirmation?.index}
                        handleDelete={handleDelete}
                        onCancel={() => {

                            const updatedIsDeleteClicked = [...isDeleteClicked];

                            updatedIsDeleteClicked[
                                deleteConfirmation.index
                            ] = false;

                            setIsDeleteClicked(updatedIsDeleteClicked);

                        }}
                        promptText={promptText}
                    />
                </div>
                <ConfirmPopup
                    content={({ message, hide }) =>
                        <div className="bg-gray-900 border-round custom-tooltip">
                            <span>{message}</span>
                            <span className='d-none'>
                                {setTimeout(() => {
                                    hide()
                                }, 2000) as any}
                            </span>
                        </div>
                    }
                />
            </section>
            <div className='generation-empty-section'>
            </div>
        </div>
    )
}

export default EmailGeneration